export default __webpack_public_path__ + "static/media/12-1.7d5a1b41.mp3";